import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Navbar from '../../../Components/Navbar'
import Container from 'react-bootstrap/Container'
import { Link, Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../wallet.css'
import InsideMenu from '../../../Components/InsideMenu'
import moment from 'moment'
// import LoginWallet from '../loginWallet'
import { login } from '../../../redux-flow/actions/wallet'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import SideBar from '../../../Components/SideBar'
import { Button, Tooltip } from 'antd'
import { ReactComponent as Eye } from '../../../images/wallet/eye.svg'
import { ReactComponent as ClosedEye } from '../../../images/wallet/closed_eye.svg'
import { ReactComponent as Money } from '../../../images/wallet/money.svg'
import { ReactComponent as MoneyActive } from '../../../images/wallet/money_active.svg'
import { ReactComponent as Bars } from '../../../images/wallet/bars.svg'
import { ReactComponent as BarsActive } from '../../../images/wallet/bars_active.svg'
import { Bar, Line } from 'react-chartjs-2'
import { getInfoLocalStorage, setInfoLocalStorage } from '../../../utils/api'
import axios from 'axios'
import { getTokens } from '../../../redux-flow/actions/wallet_token'
import BoxToken from '../../../Components/BoxToken'

const stateFromLocalStorage = getInfoLocalStorage()


class FlwtPainel extends PureComponent {
    constructor(props) {
    super(props)
    this.state = {
        password: '',
        loading: false,
        currentPage: 1, 
        req: false,
        closed: true,
        bars: false,
        tokenBalance: 0,
        modalToken: false
    }}
    
    async componentDidMount() {
        const { onLoad, userid, getUserTokens, idWallet, tvlHistory, isLoading } = this.props
        if(onLoad && userid) {
            onLoad(userid)
        }
        const isPhantomInstalled = window.solana && window.solana.isPhantom
        if(isPhantomInstalled && !window.solana.isConnected) {
            try {
                const resp = await window.solana.connect();
                const key = resp.publicKey.toString()
                const phantom = { key }
                setInfoLocalStorage(phantom)
                this.handleTokenInfo()
            } catch (err) {
                console.log(err)
                // { code: 4001, message: 'User rejected the request.' }
            }
        } else {
            const tokenKey = stateFromLocalStorage.tokenKey
            const key = stateFromLocalStorage.key
            if(tokenKey && key) {
                this.handleBalance(tokenKey)
                getUserTokens(idWallet, key)
            } else {
                this.handleTokenInfo()   
            }
        }
    }

    async componentDidUpdate(prevState, prevProps) {
        const { walletLogged, tvlHistory, isLoading } = this.props
        if(walletLogged){
            this.setState({
                req: true
            })
        }
        // if(!window.solana.isConnected) {
        //     try {
        //         const resp = await window.solana.connect();
        //         const key = resp.publicKey.toString()
        //         const phantom = { key }
        //         setInfoLocalStorage(phantom)
        //         this.handleBalance()
        //         // 26qv4GCcx98RihuK3c4T6ozB3J7L6VwCuFVc7Ta2A3Uo 
        //     } catch (err) {
        //         console.log(err)
        //         // { code: 4001, message: 'User rejected the request.' }
        //     }
        // } else {
        //     this.handleBalance()
        // }
    }

    handleClose = () => {
        const aux = this.state.closed
        this.setState({
            closed: !aux
        })
    }

    handleVisualization = (type) => {
        this.setState({
            bars: type === 'money' ? true : false
        })
    }

    handleTokenInfo = async () => {
        const { userid, getUserTokens,idWallet } = this.props
        this.setState({ loading: true })
        const key = stateFromLocalStorage.key
        if(key === undefined) {
            window.location.replace("/wallet/flwt")
        } else {
            const response = await axios({
                url: `https://api.mainnet-beta.solana.com`,
                method: "post",
                headers: { "Content-Type": "application/json" },
                data: [
                    {
                      jsonrpc: "2.0",
                      id: 1,
                      method: "getTokenAccountsByOwner",
                      params: [
                        key,
                        { "mint": "JEBexgRE4xdNHeNAv7c3GCSC7wg3DUwXJybxUNEgiUzD"},
                        { "encoding": "base64" }
                      ],
                    }
                ]
            });
            const tokenKey = response.data[0].result.value[0].pubkey
            const tokenInfo = { tokenKey }
            setInfoLocalStorage(tokenInfo)
            this.setState({ loading: false })
            this.handleBalance(tokenKey)    
            getUserTokens(idWallet, key)
        }
    }

    handleBalance = async (tokenKey) => {
        this.setState({ loading: true })
        const response = await axios({
            url: `https://api.mainnet-beta.solana.com`,
            method: "post",
            headers: { "Content-Type": "application/json" },
            data: [
                {
                  jsonrpc: "2.0",
                  id: 1,
                  method: "getTokenAccountBalance",
                  params: [
                    tokenKey,
                  ],
                }
            ]
        }); 
        this.setState({ tokenBalance: response.data[0].result.value.uiAmount, loading: false })
    }

    handleModalToken = () => {
        const aux = this.state.modalToken
        this.setState({ modalToken: !aux })
    }

    formatarMoeda = (valor) => { 
        valor = Number(valor).toFixed(2) + '';
        valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor).replace('R$', '')  
        return valor;
    }
    
    sumYields = (arr) => {
        var sum = 0
        arr.forEach(e => {
            sum += parseFloat(e.yield)
        })
        return sum
    }
        
    render() {

            const { logged, userLogged, userExpiration, loginExpired, walletLogged, isLoading, tokensUser, tvlHistory, taxa, chart, rewards, totalRewards, chartFLWT, tokensMonth, tokensApprovals } = this.props  
            return (
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> : (
                        userLogged.permissao === 0 || userLogged.permissao === 2 || userLogged.permissao === 4 ? <Redirect to="/minhaconta" /> :
                        <div>
                            <Container>
                                    <div className="section minhaContaWrapper">
                                        <Row>
                                            <Col md={12} className="p-0">
                                                <InsideMenu /> 
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="section insideSec">
                                        <Row>
                                            <Col md={2} className="p-0" style={{borderRight: '1px solid #F6F3FF'}}>
                                                <SideBar permissao={userLogged.permissao} nivelVerificacao={userLogged.nivelVerificacao} />
                                            </Col>
                                            <Col md={10}>
                                            <div>
                                                <Row className="section">
                                                    <Col md={1}></Col>
                                                    <Col md={11}>
                                                        <h4 className="tx-gray text-left font-weight-bold p-0 titleFlwt">FLWT</h4>
                                                        <Row className="mt-5">
                                                            <Col md={8}>
                                                                <label className="tx-pink font-weight-bold">Endereço Phantom Wallet</label><br />
                                                                <label className="tx-gray text-break">{stateFromLocalStorage.key || "Carteira não conectada"}</label>
                                                            </Col>
                                                            <Col md={2} xs={6}>
                                                                <label className="tx-pink font-weight-bold">Saldo FLWT</label><br />
                                                                <label className="tx-gray">{this.state.tokenBalance}</label>
                                                            </Col>
                                                            <Col md={2} xs={6} className="d-flex align-items-center">
                                                                <Button onClick={this.handleModalToken} className="btnGrafico">Comprar</Button>
                                                            </Col>
                                                            <Col md={12}>
                                                                <hr className='flwtDivisor' />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8} className="mt-3 pr-5">
                                                                <h5 className="font-weight-bold tx-pink text-left p-0">Total Value Locked</h5>
                                                                <h2 className="tx-gray font-weight-bold">R${!isLoading && tvlHistory.length > 0 && this.formatarMoeda(this.sumYields(tvlHistory) + (tokensMonth*500))}{tokensApprovals > 0 && <small className="saldoAprovacao">(+R${tokensApprovals*500} em aprovação)</small>}</h2>
                                                                <Row>
                                                                    <Col md={6} xs={6}>
                                                                        <label className="tx-light-gray">1ª compra</label>
                                                                    </Col>
                                                                    <Col md={6} xs={6}>
                                                                        <label className="tx-light-gray text-right w-100">R${!isLoading && tvlHistory.length > 0 && this.formatarMoeda(tvlHistory[0]['totalTokens']*500)}</label>
                                                                    </Col>
                                                                    <Col md={6} xs={6}>
                                                                        <label className="tx-light-gray d-flex">Liquidity Pool<Tooltip title="Valor total aportado em reais"><div className='modalInfoIcon ml-2'>?</div></Tooltip></label>
                                                                    </Col>
                                                                    <Col md={6} xs={6}>
                                                                        <label className="tx-light-gray text-right w-100">R${!isLoading && tvlHistory.length > 0 && this.formatarMoeda(tokensMonth*500)}</label>
                                                                    </Col>
                                                                    <Col md={6} xs={8}>
                                                                        <label className="tx-light-gray">{this.state.closed ? <Eye className='mr-1 cursor-pointer' onClick={this.handleClose} role="button" /> : <ClosedEye className='mr-1 cursor-pointer' onClick={this.handleClose} role="button" />} Yield (últimos 12 meses)</label>
                                                                    </Col>
                                                                    <Col md={6} xs={4}>
                                                                        <label className="tx-light-gray text-right w-100">R${!isLoading && tvlHistory.length > 0 && this.formatarMoeda(this.sumYields(tvlHistory))}</label>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col md={4} className="mt-3">
                                                                {!this.state.closed &&
                                                                <>
                                                                    <label className="tx-pink font-weight-bold p-0 text-left m-0">Yield (Últimos 12 meses)</label><br />
                                                                    <div className="listYield w-100 mt-2">
                                                                        {tvlHistory.map(history => (
                                                                            <div className="d-flex w-100 justify-content-between">
                                                                                <label className="tx-light-gray">{moment(history.createdAt).subtract(1, 'M').format("MMMM")}</label>
                                                                                <label className="tx-light-gray">R${this.formatarMoeda(history.yield)}</label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </>}
                                                            </Col>
                                                            <Col md={12}>
                                                                <hr className='flwtDivisor' />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mt-3">
                                                            <Col md={12}>
                                                                <label className="tx-pink font-weight-bold">Dividendos de participação</label>
                                                            </Col>
                                                            <Col md={6} className="d-flex mt-3">
                                                                <small className="tx-light-gray">Últimos 12 meses</small>
                                                                <small className="tx-light-gray ml-5">R${this.formatarMoeda(Math.abs(totalRewards/100))}</small>
                                                            </Col>
                                                            <Col md={6} className="d-flex mt-3 justify-content-end align-items-center reverse-mobile">
                                                                <small className="tx-gray">Visualização</small>
                                                                {!this.state.bars ? <MoneyActive role="button" onClick={() => this.handleVisualization('bars')} className="ml-3 mr-3" /> : <Money role="button" onClick={() => this.handleVisualization('bars')} className="ml-3 mr-3" / >}
                                                                {this.state.bars ? <BarsActive role="button" onClick={() => this.handleVisualization('money')} /> : <Bars role="button" onClick={() => this.handleVisualization('money')} />}
                                                            </Col>
                                                            <Col md={12} className="mt-2">
                                                                {this.state.bars ? <Bar data={chartFLWT} options={chartFLWT.options} /> :
                                                                <div className='d-flex w-100 overflow-auto'>
                                                                    {isLoading ? 'Carregando histórico de dividendos' : rewards.length <= 0 ? 'Não há histórico' : rewards.map((reward, i) => (
                                                                        <div className={`cardDividendos ${i !== 0 && 'ml-3'}`}>
                                                                            <label className="tx-pink font-weight-bold text-capitalize">{moment(reward.createdAt).subtract(1, 'M').format("MMMM")} {moment(reward).subtract(1, 'M').format("YYYY")}</label><br />
                                                                            <label className="tx-gray mt-2">R${this.formatarMoeda(parseInt(reward.valor)/100)}</label><br />
                                                                            <label className="statusTransferido mt-2">Transferido</label>
                                                                        </div>
                                                                    )) }
                                                                </div> }<br />
                                                                <Link to="/wallet/extrato"><small className="tx-gray mt-2" style={{textDecoration: 'underline'}}>Conferir extrato na wallet</small></Link>
                                                            </Col>  
                                                            <Col md={12}>
                                                                <hr className='flwtDivisor' />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mt-3">
                                                            <Col md={12}>
                                                                <h4 className="tx-pink text-left font-weight-bold">Yield FLWT</h4>
                                                            </Col> 
                                                            <Col md={8}>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <label className="tx-pink font-weight-bold">Gráfico de evolução</label>
                                                                    </Col>
                                                                    <Col md={6}></Col>
                                                                    <Col md={12}>
                                                                        <Line data={chart} options={chart.options} />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col md={4}>
                                                                <label className="tx-pink font-weight-bold taxa-anual">Taxa Anual</label><br />
                                                                <h3 className="tx-gray font-weight-bold text-left">{!isLoading && parseInt(taxa)}%</h3>
                                                            </Col>
                                                        </Row>
                                                        <Row className="mt-5">
                                                            <Col md={12}>
                                                                <label className="tx-pink font-weight-bold">Histórico de Yield</label>
                                                                <div className="d-flex w-100 mt-2 overflow-auto dividendosWrapper">
                                                                    {!isLoading && tvlHistory.length > 0 ?
                                                                        tvlHistory.map((tvl, i) => (
                                                                            <div className={`cardDividendos ${i !== 0 && 'ml-3'}`}>
                                                                                <label className="tx-pink font-weight-bold text-capitalize">{moment(tvl.createdAt).subtract(1, 'M').format("MMMM")} 2022</label><br />
                                                                                <label className="tx-gray mt-2">R${this.formatarMoeda(tvl.yield)}</label><br />
                                                                                <label className="statusPassado mt-2">Concluído</label>
                                                                            </div>
                                                                        )) : 'Não há histórico'
                                                                    }
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                <BoxToken modalToken={this.state.modalToken} handleModal={this.handleModalToken} />
                                </Container>
                        </div>
                        
                    )}
                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
    userid: state.login.userid,
    userExpiration: state.wallet.userExpiration,
    idWallet: state.wallet.idWallet,
    loginExpired: state.wallet.loginExpired,
    walletLogged: state.wallet.walletLogged,
    success: state.wallet_token.success,
    isLoading: state.wallet_token.isLoading,
    tvlHistory: state.wallet_token.tvlHistory,
    taxa: state.wallet_token.taxa,
    chart: state.wallet_token.chart,
    rewards: state.wallet_token.rewards,
    totalRewards: state.wallet_token.totalRewards,
    chartFLWT: state.wallet_token.chartFLWT,
    tokensMonth: state.wallet_token.tokensMonth,
    tokensApprovals: state.wallet_token.tokensApprovals
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    },
    handleSubmit: (pass, email, userid) => {
        dispatch(login(pass, email, userid))
    },
    getUserTokens: (idWallet, address) => {
        dispatch(getTokens(idWallet, address))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(FlwtPainel)